import { capitalize } from './capitalize';

export const changeNameToCamelCase = (name: string) => {
  const splitName = name.split('_');
  return [splitName[0], capitalize(splitName?.[1])].join('');
};